(function () {
  if (window.__ggCollectorJourneyEvents) return;
  window.__ggCollectorJourneyEvents = true;

  window.dataLayer = window.dataLayer || [];

  function classValue(prefix) {
    var bodyClass = document.body ? String(document.body.className || '') : '';
    var classes = bodyClass.split(/\s+/);
    for (var i = 0; i < classes.length; i += 1) {
      if (classes[i].indexOf(prefix) === 0) return classes[i].slice(prefix.length);
    }
    return '';
  }

  var context = {
    page_type: classValue('template-') || 'unknown',
    template_suffix: classValue('template-suffix-') || 'default',
    handle: '',
    page_title: document.title || '',
    artist: '',
    category: '',
    path: window.location.pathname,
    page_group: pageGroup(window.location.pathname),
    query_string: window.location.search ? window.location.search.slice(0, 200) : '',
    referrer_host: referrerHost(document.referrer),
    landing_page: isLandingPage()
  };

  function pageGroup(path) {
    if (/^\/products\//.test(path)) return 'product';
    if (/^\/collections\//.test(path)) return 'collection';
    if (/^\/blogs\//.test(path)) return 'article';
    if (/^\/pages\//.test(path)) return 'page';
    if (/^\/search/.test(path)) return 'search';
    if (/^\/cart/.test(path)) return 'cart';
    return path === '/' ? 'home' : 'other';
  }

  function referrerHost(referrer) {
    try { return referrer ? new URL(referrer).hostname : ''; } catch (e) { return ''; }
  }

  function isLandingPage() {
    try { return !document.referrer || new URL(document.referrer).hostname !== window.location.hostname; } catch (e) { return !document.referrer; }
  }

  function textOf(el) {
    if (!el) return '';
    var label = el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || '';
    return String(label).replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function closestAction(target) {
    if (!target || !target.closest) return null;
    return target.closest('a, button, [role="button"], input[type="submit"]');
  }

  function classify(el, href, text) {
    // Product names can contain 'COA' or 'authentication'; these are shopping links.
    if (el.closest('.gg-available-picks') && /^https?:\/\//.test(href) && /\/(products|collections)\//.test(href)) return 'inventory';
    var haystack = [
      href,
      text,
      el.id || '',
      el.className || '',
      el.getAttribute('data-analytics-event') || '',
      el.getAttribute('data-product-handle') || '',
      el.getAttribute('aria-label') || ''
    ].join(' ').toLowerCase();

    if (haystack.indexOf('wishlist') !== -1 || el.matches('.tile-heart, [data-gg-wishlist], [data-gg-wishlist-header]')) return 'wishlist';
    if (haystack.indexOf('add to cart') !== -1 || haystack.indexOf('/cart/add') !== -1 || el.closest('form[action*="/cart/add"]')) return 'add_to_cart';
    if (haystack.indexOf('make an offer') !== -1 || haystack.indexOf('source') !== -1 || haystack.indexOf('sourcing') !== -1 || haystack.indexOf('contact') !== -1 || haystack.indexOf('mailto:') !== -1) return 'request';
    if (haystack.indexOf('auth') !== -1 || haystack.indexOf('fake') !== -1 || haystack.indexOf('coa') !== -1 || haystack.indexOf('truecoa') !== -1) return 'authentication';
    if (haystack.indexOf('price') !== -1 || haystack.indexOf('pricing') !== -1 || haystack.indexOf('market') !== -1 || haystack.indexOf('financial') !== -1 || haystack.indexOf('value') !== -1 || haystack.indexOf('appraisal') !== -1) return 'pricing';
    if (haystack.indexOf('guide') !== -1 || haystack.indexOf('faq') !== -1 || haystack.indexOf('reference') !== -1 || haystack.indexOf('learn') !== -1) return 'guide';
    if (href.indexOf('/products/') !== -1 || href.indexOf('/collections/') !== -1) return 'inventory';
    if (haystack.indexOf('video') !== -1 || haystack.indexOf('sound') !== -1) return 'video';
    return '';
  }

  function push(name, detail) {
    var payload = {};
    Object.keys(context).forEach(function (key) { payload[key] = context[key]; });
    Object.keys(detail || {}).forEach(function (key) { payload[key] = detail[key]; });
    payload.event = name;
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      var gtagPayload = {};
      Object.keys(payload).forEach(function (key) {
        if (key !== 'event') gtagPayload[key] = payload[key];
      });
      window.gtag('event', name, gtagPayload);
    }
  }

  window.GauntletAnalytics = window.GauntletAnalytics || {};
  window.GauntletAnalytics.trackCollectorEvent = push;

  var PENDING_CART_KEY = 'gg_pending_cart_add_v1';

  function readPendingCartAdd() {
    try {
      var value = window.sessionStorage.getItem(PENDING_CART_KEY);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function writePendingCartAdd(detail) {
    try {
      window.sessionStorage.setItem(PENDING_CART_KEY, JSON.stringify(detail));
    } catch (error) {
      /* Tracking must never block Shopify's cart form. */
    }
  }

  function clearPendingCartAdd() {
    try {
      window.sessionStorage.removeItem(PENDING_CART_KEY);
    } catch (error) {
      /* Ignore unavailable storage. */
    }
  }

  function formCartDetail(form) {
    var formData;
    try {
      formData = new FormData(form);
    } catch (error) {
      return { form_action: form.getAttribute('action') || '' };
    }

    return {
      form_action: form.getAttribute('action') || '',
      variant_id: String(formData.get('id') || ''),
      quantity: Math.max(1, Number(formData.get('quantity')) || 1),
      source_path: window.location.pathname,
      submitted_at: Date.now()
    };
  }

  function confirmPendingCartAdd() {
    var pending = readPendingCartAdd();
    if (!pending || !pending.variant_id) return;

    if (!pending.submitted_at || Date.now() - pending.submitted_at > 120000) {
      clearPendingCartAdd();
      return;
    }

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart verification failed');
        return response.json();
      })
      .then(function (cart) {
        var item = (cart.items || []).find(function (candidate) {
          return String(candidate.variant_id || candidate.id) === String(pending.variant_id) &&
            Number(candidate.quantity || 0) >= Number(pending.quantity || 1);
        });
        if (!item) return;

        push('collector_add_to_cart_succeeded', {
          form_action: pending.form_action || '',
          variant_id: String(item.variant_id || item.id || pending.variant_id),
          quantity: Number(pending.quantity || 1),
          cart_quantity: Number(cart.item_count || 0),
          confirmation_source: 'cart_state'
        });
        clearPendingCartAdd();
      })
      .catch(function () {
        /* Keep the pending record for the redirect/reload path to verify later. */
      });
  }

  context.handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [,''])[1] ||
    (window.location.pathname.match(/\/collections\/([^/?#]+)/) || [,''])[1] || '';
  context.page_title = document.title || context.page_title;
  var primaryHeading = document.querySelector('h1');
  if (primaryHeading && primaryHeading.textContent.trim()) context.page_heading = primaryHeading.textContent.trim().slice(0, 160);

  push('collector_page_viewed', {
    event_origin: 'theme',
    referrer: document.referrer || ''
  });

  document.addEventListener('click', function (event) {
    var el = closestAction(event.target);
    if (!el) return;

    var href = '';
    if (el.tagName === 'A') href = el.href || '';
    else if (el.closest('a')) href = el.closest('a').href || '';

    var text = textOf(el);
    var actionType = classify(el, href, text);
    if (!actionType) return;

    var detail = {
      action_type: actionType,
      link_text: text,
      href: href,
      product_id: el.getAttribute('data-product-id') || el.getAttribute('data-gg-product-id') || '',
      inventory_placement: (el.closest('[data-gg-placement]') || el).getAttribute('data-gg-placement') || '',
      variant_id: el.getAttribute('data-variant-id') || '',
      product_handle: el.getAttribute('data-product-handle') || ''
    };

    if (actionType === 'wishlist') push('collector_wishlist_clicked', detail);
    else if (actionType === 'add_to_cart') push('collector_add_to_cart_clicked', detail);
    else if (actionType === 'request') push('collector_request_started', detail);
    else if (actionType === 'authentication') push('collector_authentication_clicked', detail);
    else if (actionType === 'pricing') push('collector_pricing_clicked', detail);
    else if (actionType === 'guide') push('collector_guide_clicked', detail);
    else if (actionType === 'inventory') push('collector_inventory_clicked', detail);
    else if (actionType === 'video') push('collector_video_interaction', detail);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    var action = form.getAttribute('action') || '';
    var formClass = form.className || '';
    if (action.indexOf('/cart/add') !== -1) {
      var detail = formCartDetail(form);
      writePendingCartAdd(detail);
      push('collector_add_to_cart_attempted', detail);
    } else if (action.indexOf('/contact') !== -1 || formClass.indexOf('contact') !== -1) {
      push('collector_request_submitted', { form_action: action });
    }
  }, true);

  document.addEventListener('switch:cart:afteradditem', function (event) {
    var pending = readPendingCartAdd() || {};
    var response = (event.detail && event.detail.response) || {};
    push('collector_add_to_cart_succeeded', {
      form_action: pending.form_action || '',
      variant_id: String(response.variant_id || response.id || pending.variant_id || ''),
      quantity: Number(response.quantity || pending.quantity || 1),
      confirmation_source: 'shopify_response'
    });
    clearPendingCartAdd();
  });

  document.addEventListener('switch:productform:adderror', function (event) {
    var pending = readPendingCartAdd() || {};
    var detail = (event && event.detail) || {};
    push('collector_add_to_cart_failed', {
      form_action: pending.form_action || '',
      variant_id: String(detail.variantId || pending.variant_id || ''),
      error_type: 'shopify_rejected'
    });
    clearPendingCartAdd();
  });

  document.addEventListener('gg:wishlist:count', function (event) {
    var count = event.detail && Number.isFinite(Number(event.detail.count)) ? Number(event.detail.count) : 0;
    push('collector_wishlist_count_changed', { wishlist_count: count });
  });

  function bindVideoEvents() {
    document.querySelectorAll('video').forEach(function (video) {
      if (video.dataset.ggCollectorVideoBound) return;
      video.dataset.ggCollectorVideoBound = 'true';
      ['play', 'pause', 'ended'].forEach(function (name) {
        video.addEventListener(name, function () {
          push('collector_video_interaction', {
            action_type: 'video',
            video_action: name,
            video_src: video.currentSrc || video.getAttribute('src') || ''
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindVideoEvents();
      confirmPendingCartAdd();
    });
  } else {
    bindVideoEvents();
    confirmPendingCartAdd();
  }
  document.addEventListener('shopify:section:load', bindVideoEvents);
})();
